export const currenciesFo = {
  AED: '',
  AFN: '',
  ALL: '',
  AMD: '',
  AOA: '',
  ARS: '',
  AUD: '',
  AWG: '',
  AZN: '',
  BAM: '',
  BBD: '',
  BDT: '',
  BGN: '',
  BHD: '',
  BIF: '',
  BMD: '',
  BND: '',
  BOB: '',
  BRL: '',
  BSD: '',
  BTN: '',
  BWP: '',
  BYR: '',
  BZD: '',
  CAD: '',
  CDF: '',
  CHF: '',
  CLP: '',
  CNY: '',
  COP: '',
  CRC: '',
  CUC: '',
  CUP: '',
  CVE: '',
  CZK: '',
  DJF: '',
  DKK: '',
  DOP: '',
  DZD: '',
  EGP: '',
  EUR: '',
  ERN: '',
  ETB: '',
  FJD: '',
  FKP: '',
  GBP: '',
  GEL: '',
  GHS: '',
  GIP: '',
  GMD: '',
  GNF: '',
  GTQ: '',
  GYD: '',
  HKD: '',
  HNL: '',
  HRK: '',
  HTG: '',
  HUF: '',
  IDR: '',
  ILS: '',
  INR: '',
  IQD: '',
  IRR: '',
  ISK: '',
  JMD: '',
  JOD: '',
  JPY: '',
  KES: '',
  KGS: '',
  KHR: '',
  KMF: '',
  KPW: '',
  KRW: '',
  KWD: '',
  KYD: '',
  KZT: '',
  LAK: '',
  LBP: '',
  LKR: '',
  LRD: '',
  LSL: '',
  LYD: '',
  MAD: '',
  MDL: '',
  MGA: '',
  MKD: '',
  MMK: '',
  MNT: '',
  MOP: '',
  MRO: '',
  MUR: '',
  MVR: '',
  MWK: '',
  MXN: '',
  MYR: '',
  MZN: '',
  NAD: '',
  NGN: '',
  NIO: '',
  NOK: '',
  NPR: '',
  NZD: '',
  OMR: '',
  PAB: '',
  PEN: '',
  PGK: '',
  PHP: '',
  PKR: '',
  PLN: '',
  PYG: '',
  QAR: '',
  RON: '',
  RSD: '',
  RUB: '',
  RWF: '',
  SAR: '',
  SBD: '',
  SCR: '',
  SDG: '',
  SEK: '',
  SGD: '',
  SHP: '',
  SLL: '',
  SOS: '',
  SRD: '',
  SSP: '',
  STD: '',
  SYP: '',
  SZL: '',
  THB: '',
  TJS: '',
  TMM: '',
  TND: '',
  TOP: '',
  TRY: '',
  TTD: '',
  TWD: '',
  TZS: '',
  UAH: '',
  UGX: '',
  USD: '',
  UYU: '',
  UZS: '',
  VEF: '',
  VND: '',
  VUV: '',
  WST: '',
  YER: '',
  ZAR: '',
  ZMW: '',
  ZWL: '',
  ANG: '',
} as const;
